
















import { Component, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

@Component({
  computed: {
    ...mapGetters("network", ["allApps"]),
  },
})
export default class AppsCount extends Vue {
  public mounted() {}
}
